import * as React from 'react'
import { VyneRadio } from '@vynedental/design-system'
import { RadioChangeEvent } from 'antd'

import WidgetPlacementSVGIcon from './WidgetPlacementSVGIcon'

import './WidgetIconPlacement.sass'

export type WidgetIconPlacementProps = {
    customValue?: Api.widgetIconPosition | boolean
    updateIconPlacement: (iconPlacement: Api.widgetIconPosition) => void
}

export default class WidgetIconPlacement extends React.Component<WidgetIconPlacementProps> {
    updateIconPlacement = (e: RadioChangeEvent) => {
        this.props.updateIconPlacement(e.target.value as Api.widgetIconPosition)
    }

    render() {
        const { customValue } = this.props
        const radioValue = customValue || 'lower-right'

        return (
            <div className="widget-icon-placement">
                <h3>Placement:</h3>
                <div className="radio-wrapper">
                    <VyneRadio
                        dataTestId="icon-lower-right"
                        checked={radioValue === 'lower-right'}
                        onChange={this.updateIconPlacement}
                        name="radio-widget-placement"
                        value="lower-right"
                        isStandalone
                        style={{ marginBottom: 0 }}
                    >
                        Lower Right
                    </VyneRadio>
                    <div className="widget-icon-wrapper widget-lower-right">
                        <WidgetPlacementSVGIcon />
                    </div>
                </div>
                <div className="radio-wrapper">
                    <VyneRadio
                        dataTestId="icon-lower-left"
                        checked={radioValue === 'lower-left'}
                        onChange={this.updateIconPlacement}
                        name="radio-widget-placement"
                        value="lower-left"
                        isStandalone
                        style={{ marginBottom: 0 }}
                    >
                        Lower Left
                    </VyneRadio>
                    <div className="widget-icon-wrapper widget-lower-left">
                        <WidgetPlacementSVGIcon />
                    </div>
                </div>
            </div>
        )
    }
}
